import { useCallback } from "react";

const useAmountLabel = () => {
    const callbackAmountLabel = useCallback((value: any) => {
        if (typeof value !== "number") {
            return value;
        }

        if (value === 0) {
            return "$0";
        }
        if (value >= 1000000) {
            const label = parseFloat(`${value / 1000000}`).toFixed(2);
            return `$${label}M`;
        }

        const label = parseFloat(`${value / 1000}`);

        if (value >= 10000) {
            return `$${label.toFixed(0)}K`;
        }
        return `$${label.toFixed(1)}K`;
    }, []);

    return { callbackAmountLabel };
};

export default useAmountLabel;
